import { AdminCompaniesLazy, AdminLoyaltyLazy, AdminPeopleLazy, AdminSettingsLazy } from 'components/router/appRoutes';
import {
  ADMIN_COMPANIES_ROUTE,
  ADMIN_LOYALTY_ROUTE,
  ADMIN_PEOPLE_ROUTE,
  ADMIN_SETTINGS_ROUTE,
  SAFETY_ROUTE,
} from 'constants/routes';
import { UCMapLazy } from 'components/safety/safetyBase';

export const preloadLazyPages = (route) => {
  switch (route) {
    case SAFETY_ROUTE:
      UCMapLazy.preloadFn();
      break;
    default:
      break;
  }
};

export const preloadAdminLazyPages = (route) => {
  switch (route) {
    case ADMIN_COMPANIES_ROUTE:
      AdminCompaniesLazy.preloadFn();
      break;
    case ADMIN_PEOPLE_ROUTE:
      AdminPeopleLazy.preloadFn();
      break;
    case ADMIN_LOYALTY_ROUTE:
      AdminLoyaltyLazy.preloadFn();
      break;
    case ADMIN_SETTINGS_ROUTE:
      AdminSettingsLazy.preloadFn();
      break;
    default:
      break;
  }
};
